var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Parses an age value.
 * @param value The value to parse
 * @category Value parsers
 */
export var parseAge = function (value) {
    if (!value) {
        return null;
    }
    var sign = '<>'.indexOf(value[0]);
    var hasSign = sign >= 0;
    var remaining = hasSign ? value.substring(1) : value;
    var isChild = remaining === 'CHILD';
    var isInfant = remaining === 'INFANT';
    var isStillborn = remaining === 'STILLBORN';
    var common = { isGreaterThan: sign === 1, isLessThan: sign === 0, isChild: isChild, isInfant: isInfant, isStillborn: isStillborn };
    if (isChild || isInfant || isStillborn) {
        return __assign({ hasDate: false }, common);
    }
    else {
        var parts = remaining.split(' ');
        if (parts.length > 3) {
            return null;
        }
        var rNumber_1 = /^(?:0|[1-9][0-9]{0,2})$/;
        var rFormat = /^(?:ymd|y|m|d|ym|yd|md)$/;
        var result = parts.map(function (part) {
            if (part.length < 2) {
                return null;
            }
            var suffix = part[part.length - 1];
            if (!'ymd'.includes(suffix)) {
                return null;
            }
            var init = part.substring(0, part.length - 1);
            if (init.match(rNumber_1) !== null) {
                var number = parseInt(init);
                if ((suffix === 'd' && number > 365) || (suffix === 'm' && number > 11)) {
                    return null;
                }
                return [suffix, number];
            }
            else {
                return null;
            }
        });
        if (result.includes(null)) {
            return null;
        }
        var resultNonNull = result;
        if (resultNonNull.map(function (r) { return r[0]; }).join('').match(rFormat) === null) {
            return null;
        }
        var years_1 = 0, months_1 = 0, days_1 = 0;
        resultNonNull.forEach(function (_a) {
            var _b = __read(_a, 2), identifier = _b[0], number = _b[1];
            if (identifier === 'y') {
                years_1 = number;
            }
            else if (identifier === 'm') {
                months_1 = number;
            }
            else {
                days_1 = number;
            }
        });
        return __assign({ hasDate: true, date: { years: years_1, months: months_1, days: days_1 } }, common);
    }
};
//# sourceMappingURL=age.js.map